(()=>{'use strict';
const allowed=new Set(['none','natural','dark','black','white']);
const views=new Set(['artwork','lifestyle']);
const root=document.documentElement;
const storageKey='sm:collection-frame:v1';
const viewStorageKey='sm:collection-view:v1';
const readSavedView=()=>{
  try{const value=sessionStorage.getItem(viewStorageKey);return views.has(value)?value:null;}
  catch{return null;}
};
const saveView=()=>{try{sessionStorage.setItem(viewStorageKey,view);}catch{}};
const readSaved=()=>{
  try{const color=sessionStorage.getItem(storageKey);return allowed.has(color)?color:null;}
  catch{return null;}
};
let current=readSaved()||(allowed.has(root.dataset.smCollectionFrame)?root.dataset.smCollectionFrame:'natural');
let view=readSavedView()||(views.has(root.dataset.smCollectionView)?root.dataset.smCollectionView:'artwork');
root.dataset.smCollectionFrame=current;
root.dataset.smCollectionView=view;
const positionMenu=control=>{
  if(!control.getBoundingClientRect)return;
  const section=control.closest('.shopify-section');
  const toolbar=control.closest('.collection-toolbar')||control.closest('.sm-collection-toolbar');
  const firstMedia=section?.querySelector('.product-card__media');
  const boundary=Math.max(toolbar?.getBoundingClientRect().bottom||0,
    firstMedia?.getBoundingClientRect().top||0);
  const offset=boundary-control.getBoundingClientRect().top;
  if(offset>0)control.style.setProperty('--sm-frame-menu-top',offset+'px');
};
const closeMenus=(focus=false)=>document.querySelectorAll('[data-sm-frame-control]').forEach(control=>{
  const toggle=control.querySelector('[data-sm-frame-toggle]');
  const wasOpen=control.dataset.open==='true';
  delete control.dataset.open;
  toggle?.setAttribute('aria-expanded','false');
  if(focus&&wasOpen)toggle?.focus();
});
const syncButtons=()=>{
  document.querySelectorAll('[data-sm-frame-picker] button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.smFrame===current)));
  document.querySelectorAll('[data-sm-view-picker] button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.smView===view)));
  document.querySelectorAll('[data-sm-frame-control]').forEach(control=>{
    const selected=control.querySelector('[data-sm-frame="'+current+'"]');
    const toggle=control.querySelector('[data-sm-frame-toggle]');
    if(!selected||!toggle)return;
    for(const color of allowed)toggle.classList.toggle('sm-collection-frame-picker__option--'+color,color===current);
    const label=selected.getAttribute('aria-label');
    toggle.setAttribute('aria-label','Frame: '+label+'. Choose frame');
    const icon=selected.querySelector('.sm-collection-frame-picker__icon');
    if(icon)toggle.querySelector('[data-sm-current-icon]').replaceChildren(icon.cloneNode(true));
  });
};
const syncCards=(scope=document,restore=false)=>{
  const cards=scope.matches?.('sm-frame-preview[data-collection-card]')?[scope]:[...scope.querySelectorAll('sm-frame-preview[data-collection-card]')];
  for(const el of cards){
    el.dataset.requestedFrame=current;
    if(!el.profile)continue;
    if(restore)el.restoreCollectionFrame(current,true);
    else el.setCollectionFrame(current);
  }
};
const syncSlides=(scope=document)=>{
  const cards=scope.matches?.('.product-card__media')?[scope]:[...scope.querySelectorAll('.product-card__media')];
  for(const media of cards){
    const secondary=media.querySelector('.product-card__image--secondary');
    const showSecondary=view==='lifestyle'&&Boolean(secondary)&&!media.hasAttribute('data-sm-lifestyle-excluded');
    media.classList.remove('is-dragging');
    media.classList.toggle('is-secondary-visible',showSecondary);
    media.classList.toggle('sm-lifestyle-view',showSecondary);
    for(const slide of media.querySelectorAll('sm-frame-preview[data-collection-card],.product-card__image--primary,.product-card__image--secondary'))slide.style.removeProperty('transform');
    media.querySelectorAll('.product-card__swipe-dots button').forEach((dot,index)=>dot.setAttribute('aria-current',String(index===(showSecondary?1:0))));
    if(showSecondary){
      secondary.loading='eager';
      secondary.fetchPriority='auto';
    }
  }
};
const setView=next=>{
  if(!views.has(next))return;
  view=next;
  saveView();
  root.dataset.smCollectionView=view;
  closeMenus();syncButtons();syncSlides();
};
const apply=color=>{
  if(!allowed.has(color))return;
  current=color;
  root.dataset.smCollectionFrame=color;
  try{sessionStorage.setItem(storageKey,color);}catch{}
  // Frame choices always reveal the selected artwork, including on mobile.
  view='artwork';root.dataset.smCollectionView=view;saveView();
  closeMenus(true);syncButtons();syncCards();syncSlides();
};
document.addEventListener('click',e=>{
  const toggle=e.target.closest('[data-sm-frame-toggle]');
  if(toggle){
    e.preventDefault();
    const control=toggle.closest('[data-sm-frame-control]');
    const open=control.dataset.open!=='true';
    closeMenus();
    if(open){positionMenu(control);control.dataset.open='true';toggle.setAttribute('aria-expanded','true');}
    return;
  }
  const tab=e.target.closest('[data-sm-view-picker] button');
  if(tab){e.preventDefault();setView(tab.dataset.smView);return;}
  const b=e.target.closest('[data-sm-frame-picker] button');
  if(b){e.preventDefault();apply(b.dataset.smFrame);return;}
  if(!e.target.closest('[data-sm-frame-control]'))closeMenus();
});
document.addEventListener('keydown',e=>{
  if(e.key==='Escape')closeMenus(true);
});
document.addEventListener('focusin',e=>{
  if(!e.target.closest('[data-sm-frame-control]'))closeMenus();
});
const observer=new MutationObserver(records=>{
  let controlsChanged=false;
  for(const record of records)for(const node of record.addedNodes){
    if(node.nodeType!==1)continue;
    if(node.matches?.('[data-sm-frame-control],[data-sm-view-picker]')||node.querySelector?.('[data-sm-frame-control],[data-sm-view-picker]'))controlsChanged=true;
    if(node.matches?.('sm-frame-preview[data-collection-card]')||node.querySelector?.('sm-frame-preview[data-collection-card]'))syncCards(node);
    if(node.matches?.('.product-card__media')||node.querySelector?.('.product-card__media'))syncSlides(node);
  }
  if(controlsChanged)syncButtons();
});
const init=()=>{syncButtons();syncCards();syncSlides();root.dataset.smCollectionViewReady='true';observer.observe(document.body,{childList:true,subtree:true});};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
window.addEventListener('resize',()=>document.querySelectorAll('[data-sm-frame-control][data-open="true"]').forEach(positionMenu));
window.addEventListener('pagehide',()=>{root.dataset.smRestoring='true';root.dataset.smHistoryHoverPaused='true';closeMenus();syncSlides();});
window.addEventListener('pageshow',event=>{
  if(event.persisted)root.dataset.smHistoryHoverPaused='true';
  const mobile=globalThis.matchMedia?.('(max-width:699px)').matches;
  if(event.persisted||mobile)root.dataset.smRestoring='true';
  // Keep explicit tab choice across collections; per-card swipes are reset
  // to that choice when returning from a product.
  view=readSavedView()||(views.has(root.dataset.smCollectionView)?root.dataset.smCollectionView:'artwork');
  root.dataset.smCollectionView=view;
  current=readSaved()||(allowed.has(root.dataset.smCollectionFrame)?root.dataset.smCollectionFrame:'natural');
  root.dataset.smCollectionFrame=current;
  closeMenus();syncButtons();syncCards();syncSlides();
  if(root.dataset.smRestoring==='true')requestAnimationFrame(()=>requestAnimationFrame(()=>{delete root.dataset.smRestoring;}));
});

let menuPositionFrame;
window.addEventListener('scroll',()=>{
  if(menuPositionFrame)return;
  menuPositionFrame=requestAnimationFrame(()=>{
    menuPositionFrame=0;
    document.querySelectorAll('[data-sm-frame-control][data-open="true"]').forEach(positionMenu);
  });
},{passive:true});

// Move the header divider below the controls only while the toolbar is pinned.
const syncToolbarDivider=()=>{
  if(!globalThis.getComputedStyle)return;
  let stuck=false;
  document.querySelectorAll('.collection-toolbar').forEach(toolbar=>{
    const top=parseFloat(getComputedStyle(toolbar).top)||0;
    const rect=toolbar.getBoundingClientRect();
    const pinned=rect.height>0&&rect.top<=top+1&&rect.bottom>top;
    toolbar.toggleAttribute('data-sm-stuck',pinned);
    stuck=stuck||pinned;
  });
  root.toggleAttribute('data-sm-toolbar-stuck',stuck);
};
window.addEventListener('scroll',syncToolbarDivider,{passive:true});
window.addEventListener('resize',syncToolbarDivider);
window.addEventListener('pageshow',syncToolbarDivider);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',syncToolbarDivider,{once:true});else syncToolbarDivider();
new MutationObserver(syncToolbarDivider).observe(root,{attributes:true,attributeFilter:['style']});

// A cached page can restore :hover under the stationary cursor. Wait for an
// actual pointer movement before allowing that card to fade to Lifestyle.
window.addEventListener('pointermove',event=>{
  if(event.movementX||event.movementY)delete root.dataset.smHistoryHoverPaused;
},{passive:true});
})();
